export default "__VITE_ASSET__BAwsCDnX__"